/* Satya Heritage theme */
(function () {
  "use strict";
  var T = window.SatyaTheme || { freeShipping: 100000, routes: {} };
  var R = T.routes || {};
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var v = cents / 100;
    return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var cleanTitle = function (t) { return String(t || "").split("(HSN")[0].split("( HSN")[0].trim(); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var el = $("#Toast"); if (!el) return;
    el.hidden = true; void el.offsetWidth; el.textContent = msg; el.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { el.hidden = true; }, 2200);
  }

  /* ---------- header: mega menus, search, mobile menu ---------- */
  var megaBtns = $$("[data-mega-toggle]");
  function closeMegas() {
    megaBtns.forEach(function (b) { b.setAttribute("aria-expanded", "false"); var m = document.getElementById(b.dataset.megaToggle); if (m) m.hidden = true; });
  }
  function openMega(btn) {
    var id = btn.dataset.megaToggle, m = document.getElementById(id), was = btn.getAttribute("aria-expanded") === "true";
    closeMegas(); var so = $("#SearchOverlay"); if (so) so.hidden = true;
    if (!was && m) { m.hidden = false; btn.setAttribute("aria-expanded", "true"); }
  }
  var hoverable = window.matchMedia("(hover: hover)").matches;
  megaBtns.forEach(function (b) {
    b.addEventListener("click", function () { openMega(b); });
    if (hoverable) b.addEventListener("mouseenter", function () { if (b.getAttribute("aria-expanded") !== "true") openMega(b); });
  });
  var header = $("[data-header]");
  if (header && hoverable) header.addEventListener("mouseleave", closeMegas);
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".mega") && !e.target.closest("[data-mega-toggle]")) closeMegas();
  });
  var so = $("#SearchOverlay");
  $$("[data-search-open]").forEach(function (b) { b.addEventListener("click", function () { closeMegas(); so.hidden = !so.hidden; if (!so.hidden) setTimeout(function () { $("#SearchInput").focus(); }, 30); }); });
  $$("[data-search-close]").forEach(function (b) { b.addEventListener("click", function () { so.hidden = true; }); });

  function openPanel(panel, scrim) { panel.hidden = false; scrim.hidden = false; document.body.style.overflow = "hidden"; }
  function closePanel(panel, scrim) { panel.hidden = true; scrim.hidden = true; document.body.style.overflow = ""; }
  var menu = $("#MenuDrawer"), menuScrim = $("#MenuScrim");
  $$("[data-menu-open]").forEach(function (b) { b.addEventListener("click", function () { openPanel(menu, menuScrim); }); });
  $$("[data-menu-close]").forEach(function (b) { b.addEventListener("click", function () { closePanel(menu, menuScrim); }); });
  if (menuScrim) menuScrim.addEventListener("click", function () { closePanel(menu, menuScrim); });

  /* ---------- cart ---------- */
  var drawer = $("#CartDrawer"), cartScrim = $("#CartScrim");
  var shipPrev = 0, lastCart = null;
  var fmt = function (cents) { return money(cents).replace(/\.00$/, ""); };
  function openCart() { if (drawer) { openPanel(drawer, cartScrim); document.body.classList.add("cart-open"); } }
  function closeCart() { if (drawer) { closePanel(drawer, cartScrim); document.body.classList.remove("cart-open"); } }
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  if (cartScrim) cartScrim.addEventListener("click", closeCart);
  $$("[data-cart-open]").forEach(function (a) {
    a.addEventListener("click", function (e) { if (!drawer || document.body.classList.contains("template-cart")) return; e.preventDefault(); shipPrev = 0; refreshCart().then(openCart); });
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); if (menu) closePanel(menu, menuScrim); closeMegas(); if (so) so.hidden = true; } });

  function getCart() { return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function addItem(id, qty) {
    return fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart"); return j; }); });
  }
  function changeLine(key, qty) {
    return fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }

  /* Free gift (e.g. incense holder) above a cart value. Writes a cart attribute so the order shows "Free gift". */
  var G = T.gift || {};
  function giftHTML(total) {
    if (!G.on || !G.min) return "";
    var left = Math.max(0, G.min - total), nm = esc(G.name || "gift");
    if (!left) return '<p class="perk"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg><b>FREE ' + nm + '</b>&nbsp;added to your order</p>';
    return '<div class="gift"><img src="' + esc(G.img || "") + '" alt="" width="40" height="40">' +
      '<p>' + (left ? 'Add <b class="amt">' + fmt(left) + '</b> more to get a <b>FREE ' + nm + '</b>' : '<b>FREE ' + nm + '</b> added to your order') + "</p></div>";
  }
  var giftSet = null;
  function syncGift(cart) {
    if (!G.on || !G.min) return;
    var want = cart.item_count > 0 && cart.total_price >= G.min, has = !!(cart.attributes && cart.attributes["Free gift"]);
    if (want === has || giftSet === want) return;
    giftSet = want;
    var a = {}; a["Free gift"] = want ? (G.name || "gift") : "";
    fetch(root + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: a }) }).catch(function () { giftSet = null; });
  }
  function shipHTML(total) {
    var left = Math.max(0, T.freeShipping - total), pct = Math.min(100, total / T.freeShipping * 100);
    if (!left) return '<div class="fs done fs--done"><p class="perk"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg><b>FREE shipping</b>&nbsp;unlocked</p><div class="fs-burst"></div></div>';
    return '<div class="fs' + (left ? "" : " done") + '"><div class="fs-msg">' +
      (left ? 'You’re <b class="amt">' + fmt(left) + '</b> away from <b>FREE shipping</b>' : "<b>You’ve unlocked FREE shipping</b>") +
      '</div><div class="fs-track"><i class="fs-fill" style="width:' + shipPrev + '%" data-to="' + pct + '"></i><span class="fs-truck" style="left:' + shipPrev + '%" data-to="' + pct + '"><svg viewBox="0 0 48 48"><path d="M4 13h25v19H4zM29 19h8l7 7v6H29"/><circle cx="12" cy="35" r="3.5"/><circle cx="36" cy="35" r="3.5"/></svg></span><span class="fs-goal">' + fmt(T.freeShipping) + "</span></div>" +
      '<div class="fs-burst"></div></div>';
  }
  function animShip(total) {
    var pct = Math.min(100, total / T.freeShipping * 100), was = shipPrev; shipPrev = pct;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      $$(".fs-fill").forEach(function (e) { e.style.width = e.dataset.to + "%"; });
      $$(".fs-truck").forEach(function (e) { e.style.left = Math.min(92, +e.dataset.to) + "%"; });
      $$(".amt").forEach(function (a) { a.classList.remove("pulse"); void a.offsetWidth; a.classList.add("pulse"); });
      if (was < 100 && pct >= 100 && !RM) $$(".fs-burst").forEach(function (b) {
        var h = "", cols = ["#E0861C", "#F2A93B", "#A2772A", "#2E6B3B", "#C0222B"];
        for (var i = 0; i < 22; i++) h += '<i style="--x:' + ((Math.random() * 2 - 1) * 140).toFixed(0) + "px;--y:" + (-40 - Math.random() * 90).toFixed(0) + "px;--r:" + (Math.random() * 360).toFixed(0) + "deg;--d:" + (Math.random() * .25).toFixed(2) + "s;background:" + cols[i % 5] + '"></i>';
        b.innerHTML = h;
      });
    }); });
  }

  /* "You may also like" in the cart: theme-setting list first, Shopify recommendations as fallback */
  var setUps = []; try { setUps = JSON.parse(($("[data-cart-upsells]") || {}).textContent || "[]"); } catch (e) {}
  var recCache = {};
  function upsellPool(cart) {
    if (setUps.length) return Promise.resolve(setUps.filter(function (p) { return p.available; }));
    if (!cart.items.length) return Promise.resolve([]);
    var pid = cart.items[0].product_id;
    if (recCache[pid]) return Promise.resolve(recCache[pid]);
    return fetch(root + "recommendations/products.json?product_id=" + pid + "&limit=10").then(function (r) { return r.json(); }).then(function (j) {
      recCache[pid] = (j.products || []).map(function (pr) {
        var v = (pr.variants || []).filter(function (x) { return x.available; })[0];
        return v ? { id: pr.id, title: pr.title, url: pr.url, handle: pr.handle, img: pr.featured_image, simple: pr.variants.length === 1, available: true, variant: v.id, vt: v.title, price: v.price } : null;
      }).filter(Boolean);
      return recCache[pid];
    }).catch(function () { return []; });
  }
  function upsellHTML(cart) {
    if (!cart.items.length) return Promise.resolve("");
    var left = T.freeShipping - cart.total_price;
    return upsellPool(cart).then(function (pool) {
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      var list = pool.filter(function (p) { return !inCart[p.id]; });
      list.sort(function (a, b) {
        var ar = left > 0 && a.price >= left, br = left > 0 && b.price >= left;
        if (ar !== br) return ar ? -1 : 1;
        return a.price - b.price;
      });
      list = list.slice(0, 3);
      if (!list.length) return "";
      return '<p class="cartd__upsh">You may also like</p><div class="cartd__uplist">' + list.map(function (p) {
        var img = p.img ? (p.img.indexOf("//") === 0 ? "https:" + p.img : p.img) : "";
        var reach = left > 0 && p.price >= left;
        return '<div class="upr"><a class="upr__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf("?") > -1 ? "&" : "?") + 'width=120" alt="" width="52" height="52" loading="lazy">' : "") + "</a>" +
          '<div class="upr__info"><a class="upr__t" href="' + esc(p.url) + '">' + esc(cleanTitle(p.title)) + "</a>" +
          '<span class="upr__p"><b>' + fmt(p.sale ? Math.floor(p.price * (100 - p.sale) / 100) : p.price) + "</b>" + (p.sale ? " <s>" + fmt(p.price) + "</s>" : "") + (p.vt && p.vt !== "Default Title" ? " · " + esc(p.vt) : "") + (reach ? ' <small>unlocks free shipping</small>' : "") + "</span></div>" +
          '<button type="button" class="upr__add" data-upsell="' + p.variant + '" aria-label="Add ' + esc(cleanTitle(p.title)) + '">+ Add</button></div>';
      }).join("") + "</div>";
    });
  }

  function lineHTML(i) {
    var img = i.image ? '<img src="' + i.image + (i.image.indexOf("?") > -1 ? "&" : "?") + 'width=160" alt="" width="64" height="72">' : "<span></span>";
    return '<div class="line"><a href="' + esc(i.url) + '">' + img + "</a><div><h4><a href=\"" + esc(i.url) + '">' + esc(cleanTitle(i.product_title)) + "</a></h4>" +
      (i.variant_title ? "<small>" + esc(i.variant_title) + "</small>" : "") +
      '<div class="line__ctl"><div class="qty"><button type="button" data-line="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease quantity">−</button><input value="' + i.quantity + '" readonly aria-label="Quantity"><button type="button" data-line="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="line__rm" data-line="' + i.key + '" data-q="0">Remove</button></div>' + discTags(i) + '</div><div class="line__price"><b>' + fmt(i.final_line_price) + "</b>" + (i.original_line_price > i.final_line_price ? "<s>" + fmt(i.original_line_price) + "</s>" : "") + "</div></div>";
  }
  function discTags(i) {
    var a = (i.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean);
    return a.length ? '<span class="line__disc">' + a.map(esc).join(" · ") + " applied</span>" : "";
  }
  function savedOf(cart) { return Math.max(0, (cart.original_total_price || cart.total_price) - cart.total_price); }
  var OF = {}; try { OF = JSON.parse(($("[data-offer]") || {}).textContent || "{}"); } catch (e) {}
  function offerNudgeHTML(cart) {
    if (!OF.on || !OF.pct || !OF.min || !OF.handles || !OF.handles.length) return "";
    if (savedOf(cart) > 0) return "";
    var q = 0; cart.items.forEach(function (i) { if (OF.handles.indexOf(i.handle) > -1) q += i.original_line_price; });
    if (!q || q >= OF.min) return "";
    return '<p class="perk perk--offer">Add&nbsp;<b class="amt">' + fmt(OF.min - q) + "</b>&nbsp;more of offer products to get&nbsp;<b>" + OF.pct + "% OFF</b></p>";
  }
  function savedHTML(cart) {
    var sv = savedOf(cart);
    return sv > 0 ? '<p class="perk perk--save"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>You\u2019ve saved&nbsp;<b>' + fmt(sv) + "</b>&nbsp;on this order</p>" : "";
  }
  function discHTML(cart) {
    var saved = savedOf(cart);
    if (saved <= 0) return "";
    var apps = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
    cart.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (d) { var t = d.discount_application && d.discount_application.title; if (t && apps.indexOf(t) < 0) apps.push(t); }); });
    return '<div class="row cartd__discrow"><span>' + esc(apps.join(", ") || "Discount") + '</span><span>−' + fmt(saved) + "</span></div>";
  }
  function setCount(n) {
    $$("[data-cart-count]").forEach(function (c) { c.textContent = n; c.hidden = !n; c.classList.remove("pop"); void c.offsetWidth; c.classList.add("pop"); });
    var ci = $("[data-cart-count-inline]"); if (ci) ci.textContent = n ? "(" + n + ")" : "";
  }
  function renderDrawer(cart) {
    setCount(cart.item_count);
    $$("[data-cart-subtotal]").forEach(function (s) { s.textContent = fmt(cart.total_price); });
    var dEl = $("[data-cart-disc]"); if (dEl) { var dh = discHTML(cart); dEl.innerHTML = dh; dEl.hidden = !dh; }
    var empty = !cart.items.length;
    var items = $("[data-cart-items]"), emptyEl = $("[data-cart-empty]"), foot = $("[data-cart-foot]"), ups = $("[data-cart-ups]"), ship = $("[data-ship-line]");
    if (items) items.innerHTML = empty ? "" : cart.items.map(lineHTML).join("");
    if (items) items.hidden = empty;
    if (emptyEl) emptyEl.hidden = !empty;
    if (foot) foot.hidden = empty;
    if (ship) ship.innerHTML = T.freeShipping - cart.total_price <= 0 ? "Shipping: <b>FREE</b>" : "Shipping: " + fmt(T.shippingFee || 8000) + " prepaid \u00b7 " + fmt(T.shippingCod || 11000) + " cash on delivery \u00b7 FREE above " + fmt(T.freeShipping);
    $$("[data-free-shipping]").forEach(function (el) { el.hidden = empty && !!drawer && drawer.contains(el); el.innerHTML = savedHTML(cart) + offerNudgeHTML(cart) + giftHTML(cart.total_price) + shipHTML(cart.total_price); });
    syncGift(cart);
    animShip(cart.total_price);
    return upsellHTML(cart).then(function (u) { if (ups) { ups.innerHTML = u; ups.hidden = !u; } });
  }
  function refreshCart() { return getCart().then(function (cart) { lastCart = cart; return renderDrawer(cart).then(function () { return cart; }); }); }

  function afterAdd(opts) {
    return refreshCart().then(function (cart) {
      if (document.body.classList.contains("template-cart")) { location.reload(); return cart; }
      var sv = savedOf(cart);
      if (T.cartDrawer !== false && drawer) { openCart(); if (sv > 0) toast("Added \u00b7 You\u2019ve saved " + fmt(sv) + " on this order"); }
      else if (sv > 0) toast("Added \u00b7 You\u2019ve saved " + fmt(sv) + " on this order");
      else { var left = T.freeShipping - cart.total_price, gl = G.on ? G.min - cart.total_price : 0; toast(gl > 0 ? "Added · " + fmt(gl) + " more for a FREE " + (G.name || "gift") : left > 0 ? "Added · " + fmt(left) + " away from free shipping" : "Added · Free shipping unlocked"); }
      return cart;
    });
  }
  /* buttons show "Adding…" then "Added ✓" */
  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.dataset.label || btn.innerHTML; btn.disabled = true; btn.classList.add("is-loading"); btn.innerHTML = "Adding…"; }
    else { btn.classList.remove("is-loading"); btn.innerHTML = "Added ✓"; setTimeout(function () { btn.innerHTML = btn.dataset.label; btn.disabled = false; delete btn.dataset.label; }, 1500); }
  }
  function fail(btn, err) { if (btn) { btn.classList.remove("is-loading"); btn.innerHTML = btn.dataset.label || "Add to cart"; btn.disabled = false; delete btn.dataset.label; } toast(err.message); }
  function addAndOpen(id, qty, btn) {
    busy(btn, true);
    return addItem(id, qty).then(afterAdd).then(function () { busy(btn, false); }).catch(function (err) { fail(btn, err); });
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches("[data-quick-add], [data-product-form]")) return;
    if (e.submitter && e.submitter.name === "checkout") return; /* Buy it now: let Shopify handle */
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value, q = f.querySelector('[name="quantity"]');
    addAndOpen(id, q ? Math.max(1, parseInt(q.value, 10) || 1) : 1, e.submitter || f.querySelector('[type="submit"]'));
  });
  document.addEventListener("click", function (e) {
    var up = e.target.closest("[data-upsell]");
    if (up) { addAndOpen(up.dataset.upsell, 1, up); return; }
    var ln = e.target.closest("[data-line]");
    if (ln) { ln.disabled = true; changeLine(ln.dataset.line, Math.max(0, parseInt(ln.dataset.q, 10))).then(function (cart) { lastCart = cart; renderDrawer(cart); }); return; }
    var pl = e.target.closest("[data-line-change]");
    if (pl) { changeLine(pl.dataset.lineChange, Math.max(0, parseInt(pl.dataset.q, 10))).then(function () { location.reload(); }); }
  });
  /* initial render (cart page + drawer) */
  if ($$("[data-free-shipping]").length) refreshCart();

  /* small API for the other theme scripts */
  window.Satya = { addItem: addItem, afterAdd: afterAdd, addAndOpen: addAndOpen, refreshCart: refreshCart, openCart: openCart, closeCart: closeCart, money: fmt, toast: toast, esc: esc, cleanTitle: cleanTitle, busy: busy, fail: fail, root: root };

  /* ---------- dials, petals ---------- */
  function ticks(svg, n, r1, r2, every) {
    var h = "";
    for (var i = 0; i < n; i++) { var a = i / n * Math.PI * 2, k = i % every === 0, ri = k ? r1 - 8 : r1;
      h += '<line class="' + (k ? "k" : "") + '" x1="' + (200 + Math.cos(a) * ri).toFixed(1) + '" y1="' + (200 + Math.sin(a) * ri).toFixed(1) + '" x2="' + (200 + Math.cos(a) * r2).toFixed(1) + '" y2="' + (200 + Math.sin(a) * r2).toFixed(1) + '"/>'; }
    svg.innerHTML = h;
  }
  $$("[data-ticks]").forEach(function (s) { ticks(s, 144, 176, 190, 12); });
  $$("[data-dial]").forEach(function (s) { ticks(s, 120, 182, 194, 20); });
  $$("svg[data-petals]").forEach(function (svg) {
    var n = +svg.dataset.petals || 16, r1 = 150, r2 = 196, w = Math.PI / n * .8, h = "";
    var P = function (r, t) { return (200 + Math.cos(t) * r).toFixed(1) + " " + (200 + Math.sin(t) * r).toFixed(1); };
    for (var i = 0; i < n; i++) { var a = i / n * Math.PI * 2; h += '<path d="M' + P(r1, a - w) + " Q" + P(r2 - 8, a - w * .9) + " " + P(r2, a) + " Q" + P(r2 - 8, a + w * .9) + " " + P(r1, a + w) + '"/>'; }
    svg.innerHTML = h;
  });

  /* ---------- fragrance selector ---------- */
  $$("[data-selector]").forEach(function (sec) {
    var btns = $$(".flist button", sec), words = $$(".bigword span", sec), imgs = $$(".orb__img", sec), cards = $$(".fcard", sec);
    var dial = $("[data-dial]", sec), prog = $("[data-prog]", sec), i = 0, paused = false, visible = false;
    if (!btns.length) return;
    imgs[0] && imgs[0].classList.add("on");
    function sel(n, user) {
      i = n;
      btns.forEach(function (b, j) { b.setAttribute("aria-pressed", j === n); });
      words.forEach(function (w, j) { w.classList.toggle("on", j === n); });
      imgs.forEach(function (w, j) { w.classList.toggle("on", j === n); });
      cards.forEach(function (w, j) { w.classList.toggle("on", j === n); });
      if (dial) dial.style.transform = "rotate(" + (n * 360 / btns.length) + "deg)";
      if (user) paused = true;
      restart();
    }
    function restart() { if (!prog) return; prog.classList.remove("run"); void prog.offsetWidth; if (!paused && !RM) prog.classList.add("run"); }
    btns.forEach(function (b, j) { b.addEventListener("click", function () { sel(j, true); }); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) restart(); }); }, { threshold: .35 }).observe(sec);
    if (!RM) setInterval(function () { if (!paused && visible) sel((i + 1) % btns.length); }, 5000);
  });

  /* ---------- reveal + count-up ---------- */
  if (!RM && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove("pre"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px" });
    $$(".rv").forEach(function (el) { if (el.getBoundingClientRect().top > innerHeight * .95) { el.classList.add("pre"); io.observe(el); } });
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; cio.unobserve(e.target);
      var el = e.target, to = parseFloat(el.dataset.count), dec = +(el.dataset.dec || 0), suf = el.dataset.suffix || "", t0 = performance.now();
      if (isNaN(to)) return;
      (function step(t) { var k = Math.min(1, (t - t0) / 1400), v = to * (1 - Math.pow(1 - k, 3)); el.textContent = v.toLocaleString("en-IN", { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; if (k < 1) requestAnimationFrame(step); })(t0);
    }); }, { threshold: .6 });
    $$("[data-count]").forEach(function (el) { cio.observe(el); });
  }

  /* ---------- scroll: back to top, hero parallax ---------- */
  var back = $("#BackTop"), hero = $("[data-scroll=hero]"), ticking = false;
  function onScroll() {
    ticking = false;
    if (back) back.classList.toggle("on", scrollY > 1200);
    if (hero && !RM) { var r = hero.getBoundingClientRect(); hero.style.setProperty("--p", Math.min(1, Math.max(0, -r.top / r.height)).toFixed(3)); }
  }
  addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  if (back) back.addEventListener("click", function () { scrollTo({ top: 0, behavior: RM ? "auto" : "smooth" }); });
  onScroll();

  /* password recover toggle */
  var rec = $("#recover"); if (rec && !location.hash.match(/recover/)) { rec.hidden = true; $$("[data-recover]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); rec.hidden = false; }); }); }
})();
